import React from "react";
import Navbar from "../components/Navbar.js";
import Hero from "../components/tp/Hero.js";
import Sect1 from "../components/tp/Sect1.js";
import Sect2 from "../components/tp/Sect2.js";
import Sect3 from "../components/tp/Sect3.js";
import Sect4 from "../components/tp/Sect4.js";
import Sect5 from "../components/tp/Sect5.js";
import FAQs from "../components/FAQs.js";
import Aside from "../components/AsideSection.js";
import Footer from "../components/Footer.js";

const TeacherPage = () => {
  return (
    <div>
      <Navbar />
      <header>
        <Hero />
      </header>
      <main>
        <Sect1 />
        <Sect2 />
        <Sect3 />
        <Sect4 />
        <Sect5 />
        <FAQs />
      </main>
      <aside>
        <Aside />
      </aside>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default TeacherPage;
